const getters = {
    getterSearchKey: ({ filterOption }) => filterOption.searchKey,
};
export default getters;
